<template>
  <div>
    <div @click="clearMaker()">清除</div>
    <div id="fdMap" style="width: 100%; height: 800px;">

    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
    export default {
        name: "PrefectureCarMap",
        props: {
            mapShow:{
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                userInfo: localStorage.getItem('gcUserInfo')
                    ? JSON.parse(localStorage.getItem('gcUserInfo'))
                    : '',
                baiduMap: null,
                boundary: null,
                maker: [],
                qddMaker: [],
                mapData: this.GLOBAL.mapData.xzGps,
                databaseList: localStorage.getItem('clsbList')?JSON.parse(localStorage.getItem('clsbList')):[],
                qddList: localStorage.getItem('qddList')?JSON.parse(localStorage.getItem('qddList')):[],
                offlineList: [],
                allMakers: [],
                allLabel: []
            }
        },
        computed: {
            ...mapGetters({ wsInstance: 'common/wsInstance' })
        },
        watch: {
            mapShow (n,o) {
                if(n){
                    this.mapInit()
                }
            },
            wsInstance (n,o) {
                console.log(n)
                let _this = this
                n.forEach(item => {
                    _this.maker.push({
                        center: { lng: item.gps[0], lat: item.gps[1] },
                        zoom: 10,
                        show: true,
                        dragging: true,
                        msg: item.pulName
                    })
                })
                this.clearMaker()
                // this.setMaker()
                // this.setOfflineMaker()
                // this.setQddMarker()
            }
        },
        created() {
        },
        mounted() {
            if (!this.baiduMap) {
                this.mapInit()
            }
        },
        methods: {
            mapInit: function () {
                let _this = this
                // 获取登录账号所属区划信息
                let ssqhmc = this.userInfo ? this.userInfo.ssqhmc : '肥东县'
                // 默认地图中心点坐标为肥东县
                let lng = 117.575858
                let lat = 32.003189
                let size = 12
                if (ssqhmc && ssqhmc != '肥东县') {
                    size = 16
                    ssqhmc = ssqhmc.replace('肥东县', '')
                    this.mapData.forEach(item => {
                        if (item.name === ssqhmc) {
                            lng = item.longitude
                            lat = item.latitude
                        }
                    })
                    let tempQddList = []
                    this.qddList.forEach(item => {
                        if (item.xz === ssqhmc) {
                            tempQddList.push(item)
                        }
                    })
                    this.qddList = tempQddList
                }
                // 百度地图API功能
                this.baiduMap = new BMap.Map('fdMap')
                let point = new BMap.Point(lng, lat)
                this.baiduMap.centerAndZoom(point, size)
                // 鼠标缩放
                this.baiduMap.enableScrollWheelZoom(true)
                // 绘制肥东县地图轮廓
                this.boundary = new BMap.Boundary()
                this.boundary.get('合肥市肥东县', function (rs) {
                    // _this.baiduMap.clearOverlays();
                    var count = rs.boundaries.length //行政区域的点有多少个
                    if (count === 0) {
                        alert('未能获取当前行政区域')
                        return
                    }
                    //定义中国东南西北端点
                    var pNW = {
                        lat: 59.0,
                        lng: 73.0
                    } // 西北
                    var pNE = {
                        lat: 59.0,
                        lng: 136.0
                    } //东北
                    var pSE = {
                        lat: 3.0,
                        lng: 136.0
                    } //东南
                    var pSW = {
                        lat: 3.0,
                        lng: 73.0
                    } //西南
                    var pArray = []
                    pArray.push(pNW)
                    pArray.push(pSW)
                    pArray.push(pSE)
                    pArray.push(pNE)
                    pArray.push(pNW) // 向数组中添加一次闭合多边形，并将西北角再加一次作为之后画闭合区域的起点
                    var pointArray = []
                    for (var i = 0; i < count; i++) {
                        var ply = new BMap.Polygon(rs.boundaries[i], {
                            strokeWeight: 2,
                            fillColor: '',
                            strokeColor: '#37a2da',
                            fillOpacity: 0.1
                        }) //建立多边形覆盖物
                        _this.baiduMap.addOverlay(ply) //添加覆盖物
                        pointArray = pointArray.concat(ply.getPath())
                        pArray = pArray.concat(ply.getPath()) //将点增加到视野范围内
                        pArray.push(pArray[0]) // 将闭合区域加到遮蔽层上，每次添加完后要再加一次西北角作为下次添加的起点和最后一次的终点
                    }
                    if (ssqhmc === '肥东县') {
                        _this.baiduMap.setViewport(pointArray) //调整视野
                    }
                    var plyall = new BMap.Polygon(pArray, {
                        //肥东县外的遮罩
                        strokeOpacity: 0.0000001,
                        fillColor: 'white',
                        strokeColor: '#ff0000',
                        strokeWeight: 0.00001
                    })
                    // _this.baiduMap.addOverlay(plyall); //建立多边形覆盖物
                })
                // this.clearMaker()
                this.setMaker()
                this.setOfflineMaker()
                this.setQddMarker()
            },
            clearMaker() {
                let _this = this
                let overlays = this.baiduMap.getOverlays()
                let overlays_length = overlays.length
                console.log(overlays.length)
                for (let i = 0; i < overlays_length; i++) {
                    if (overlays[i].clMaker) {
                        _this.baiduMap.removeOverlay(overlays[i])
                    }
                    console.log(overlays[i].clMaker)
                }
                console.log('=========清除')
                this.maker = []
                this.setMaker()
                this.setOfflineMaker()
            },
            // 离在线设备分组
            dealAllSbGroup() {
                this.offlineList = this.databaseList
                console.log(this.offlineList)
                console.log(this.wsInstance)
                for (let i = 0; i < this.wsInstance.length; i++) {
                    this.offlineList = this.offlineList.filter(item => item.pulNo != this.wsInstance[i].pulNo)
                    console.log('================'+i+'============'+JSON.stringify(this.offlineList))
                }
            },
            // 离线车辆坐标
            setOfflineMaker() {
                this.dealAllSbGroup()
                let _this = this
                let tempMaker = []
                let temp = this.offlineList
                temp.forEach(item => {
                    tempMaker.push({
                        center: { lng: item.lng, lat: item.lat },
                        zoom: 10,
                        show: true,
                        dragging: true,
                        msg: item.pulName
                    })
                })
                tempMaker.forEach(item => {
                    //创建自定义标注
                    let pt = new BMap.Point(item.center.lng, item.center.lat)
                    let myIcon = new BMap.Icon(
                        require('../assets/image/index/pin_map_32px_1109763_easyicon.net.png'),
                        new BMap.Size(32, 32)
                    )
                    let marker2 = new BMap.Marker(pt, {icon: myIcon}) // 创建标注
                    // 创建文本标注
                    let label = new BMap.Label(item.msg, {
                        position: pt,
                        offset: new BMap.Size(-20, -50)
                    })
                    label.setStyle({
                        color: 'red',
                        border: '0',
                        fontSize: '12px',
                        background: 'rgba(0,0,0,0)'
                        // opacity: '0.1'
                    })
                    marker2.clMaker = 'clMaker'
                    label.clMaker = 'clLabel'
                    // 将标注添加到地图中
                    let opts = {
                        width: 200,
                        height: 100,
                        title: '抽粪车辆信息',
                        enableMessage: true,
                        message: ''
                    }
                    let infoWindow = new BMap.InfoWindow(item.msg, opts)
                    // marker2.addEventListener('click', function () {
                    //     _this.baiduMap.openInfoWindow(infoWindow, pt)
                    // })
                    _this.baiduMap.addOverlay(label)
                    this.baiduMap.addOverlay(marker2)
                })
                console.log('=========离线设备')
            },
            // 在线车辆坐标标点
            setMaker() {
                let _this = this
                console.log(this.wsInstance)
                console.log(this.maker)
                if (this.maker.length === 0) {
                    let temp = this.wsInstance
                    temp.forEach(item => {
                        _this.maker.push({
                            center: { lng: item.gps[0], lat: item.gps[1] },
                            zoom: 10,
                            show: true,
                            dragging: true,
                            msg: item.pulName
                        })
                    })
                }
                this.maker.forEach(item => {
                    //创建自定义标注
                    let pt = new BMap.Point(item.center.lng, item.center.lat)
                    let myIcon = new BMap.Icon(
                        require('../assets/image/index/pin_map_32px_1109763_easyicon.net.png'),
                        new BMap.Size(32, 32)
                    )
                    let marker2 = new BMap.Marker(pt, {icon: myIcon}) // 创建标注
                    // 创建文本标注
                    let label = new BMap.Label(item.msg, {
                        position: pt,
                        offset: new BMap.Size(-20, -50)
                    })
                    label.setStyle({
                        color: 'green',
                        border: '0',
                        fontSize: '12px',
                        background: 'rgba(0,0,0,0)'
                        // opacity: '0.1'
                    })
                    marker2.clMaker = 'clMaker'
                    label.clMaker = 'clLabel'
                    // 将标注添加到地图中
                    let opts = {
                        width: 200,
                        height: 100,
                        title: '抽粪车辆信息',
                        enableMessage: true,
                        message: ''
                    }
                    let infoWindow = new BMap.InfoWindow(item.msg, opts)
                    // marker2.addEventListener('click', function () {
                    //     _this.baiduMap.openInfoWindow(infoWindow, pt)
                    // })
                    _this.baiduMap.addOverlay(label)
                    this.baiduMap.addOverlay(marker2)
                })
                console.log('=========在线设备')
            },
            // 倾倒点标点
            setQddMarker() {
                let _this = this
                let qddMaker = this.qddList
                qddMaker.forEach(item => {
                    _this.qddMaker.push({
                        center: { lng: item.lng, lat: item.lat },
                        zoom: 10,
                        show: true,
                        dragging: true,
                        msg: item.qddName,
                        address: item.address
                    })
                })
                this.qddMaker.forEach(item => {
                    //创建自定义标注
                    let pt = new BMap.Point(item.center.lng, item.center.lat)
                    let myIcon = new BMap.Icon(
                        require('../assets/image/index/pin_map.png'),
                        new BMap.Size(32, 32)
                    )
                    let marker2 = new BMap.Marker(pt, {icon: myIcon}) // 创建标注
                    // 创建文本标注
                    let label = new BMap.Label(item.msg, {
                        position: pt,
                        offset: new BMap.Size(-20, -50)
                    })
                    label.setStyle({
                        color: 'blue',
                        border: '0',
                        fontSize: '12px',
                        background: 'rgba(0,0,0,0)'
                        // opacity: '0.1'
                    })
                    // 将标注添加到地图中
                    let opts = {
                        width: 200,
                        height: 100,
                        title: item.msg,
                        enableMessage: true,
                        message: item.address
                    }
                    let infoWindow = new BMap.InfoWindow(item.address, opts)
                    marker2.addEventListener('click', function () {
                        _this.baiduMap.openInfoWindow(infoWindow, pt)
                    })
                    _this.baiduMap.addOverlay(label)
                    this.baiduMap.addOverlay(marker2)
                })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PrefectureCarMap.vue